import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '@wix/da-react-context/pkg/ErrorBoundary';
import { Props } from './MediaManager';
import LoadingIndicator from '@wix/da-ds/pkg/LoadingIndicator';
import retry from '../../utils/webpack/chunkRetry';

const MediaSelector = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "mediaPopup", webpackPrefetch: true */
        './MediaManager'
      )
  )
);

export const LoadableMediaManager: React.FC<Props> = props => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const waitForMount = typeof window === 'undefined' && !mounted;
  if (waitForMount) {
    return null;
  }

  return (
    <ErrorBoundary debugComponent="LoadableMediaManager">
      <Suspense fallback={<LoadingIndicator view={'spinner'} coverMode />}>
        <MediaSelector {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};
LoadableMediaManager.displayName = 'LoadableMediaManager';

export default LoadableMediaManager;
